<template>
  <section class="tag-report tw-space-y-4">
    <h1 class="tw-text-xl tw-text-primary tw-font-bold tw-select-none">
      Tag Report
    </h1>
    <div class="tag-report tw-overflow-x-auto tw-relative">
      <table
        class="
          tw-w-full tw-text-sm tw-text-left tw-text-gray-500
          dark:tw-text-gray-400
        "
      >
        <thead
          class="
            tw-text-xs tw-text-gray-700 tw-uppercase tw-bg-gray-50
            dark:tw-bg-gray-700 dark:tw-text-gray-400
          "
        >
          <tr>
            <th scope="col" class="tw-py-3 tw-px-6">Tag name</th>
            <th scope="col" class="tw-py-3 tw-px-6">Tag type</th>
            <th scope="col" class="tw-py-3 tw-px-6">Created tickets</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="tag in tags"
            :key="tag.name"
            class="
              tw-bg-white tw-border-b
              dark:tw-bg-gray-800 dark:tw-border-gray-700
            "
          >
            <th
              scope="row"
              class="
                tw-py-4
                tw-px-6
                tw-font-medium
                tw-text-gray-900
                tw-whitespace-nowrap
                dark:tw-text-white
              "
            >
              {{ tag.title }}
            </th>
            <td class="tw-py-4 tw-px-6">{{ tag.type }}</td>
            <td class="tw-py-4 tw-px-6">{{ tag.count }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  name: "TagReport",
  data() {
    return {
      tags: [
        {
          title: "New customer",
          type: "Customer",
          count: 85,
        },
        {
          title: "Cancel order",
          type: "Order",
          count: 21,
        },
        {
          title: "Error report",
          type: "Issue",
          count: 14,
        },
        {
          title: "Old customer",
          type: "Customer",
          count: 119,
        },
      ],
    };
  },
};
</script>

<style>


</style>